
export const projectsItems = {
  filter: 'Filtrar',
};